const unlimitedDialogCountValues = new Set(['-1', 'unlimited']);

export const formatDialogCount = (
  dialogCount: string,
  unlimitedLabel: string
) =>
  unlimitedDialogCountValues.has(dialogCount) ? unlimitedLabel : dialogCount;
